module.exports = __webpack_public_path__ + "static/media/Link buttons_CKids.a7075304.png";